import base58 from '../utils/base58';

export default {
    /**
     * Solana address is encoded in base58
     * https://github.com/solana-labs/solana-web3.js/blob/master/packages/addresses/src/base58.ts
     * 
     * @param {string} address 
     * @returns 
     */
    isValidAddress(address) {
       try {
            const decoded = base58.decode(address);
            return decoded.length === 32;
       } catch (error) {
            return false;
       }
    },
};